import { Button, Flex, Icon, InputItem, List, NavBar } from "antd-mobile";
import { useCallback, useEffect, useState } from "react";
import { bottomBtnStyle } from "..";
import { ProductInfo } from "./StepTwo";

export interface ProductCard {
  productId: string;
  card: string;
}

interface threeProps {
  onCancel?: () => void;
  onOk?: (data: ProductCard[]) => void;
  productData: ProductInfo[];
  defaultValues?: ProductCard[];
}
const StepThree = ({
  onCancel,
  onOk,
  productData,
  defaultValues,
}: threeProps) => {
  const [cardNumber, setCardNumber] = useState<ProductCard[]>([]);

  useEffect(() => {
    if (defaultValues && defaultValues.length > 0) {
      setCardNumber(defaultValues);
    } else {
      if (productData.length > 0) {
        let newData: ProductCard[] = [];
        productData.forEach((element, index) => {
          if (element.product[1] === "6c2f89b5410640eaa394f8d3288709f7") {
            let obj = {
              card: "",
              productId: element.product[2],
            };
            newData[index] = obj;
          } else {
            let obj = {
              card: "",
              productId: "",
            };
            newData[index] = obj;
          }
        });
        setCardNumber(newData);
      }
    }
  }, [defaultValues, productData]);

  const onChange = useCallback(
    (value, index) => {
      const copy = JSON.parse(JSON.stringify(cardNumber));
      let obj = {
        card: value,
        productId: productData[index].product[2],
      };
      copy[index] = obj;
      setCardNumber(copy);
    },
    [cardNumber, productData]
  );
  return (
    <>
      <NavBar
        className="orderNavBar"
        icon={<Icon type="left" onClick={onCancel} />}>
        销售及内训订单
      </NavBar>
      <div className="mt45"></div>
      <List>
        {productData.length > 0 &&
          productData.map((item, index) => (
            <div key={"code" + index}>
              <div className="titleDiv">
                产品{index + 1}-{item.productName}
              </div>
              {item.product[1] === "6c2f89b5410640eaa394f8d3288709f7" && (
                <InputItem
                  placeholder="请输入"
                  onChange={(value) => onChange(value, index)}>
                  会员卡号
                </InputItem>
              )}
            </div>
          ))}
      </List>
      <Flex style={bottomBtnStyle}>
        <Flex.Item>
          <Button type="primary" onClick={onCancel}>
            上一步
          </Button>
        </Flex.Item>
        <Flex.Item>
          <Button type="primary" onClick={() => onOk?.(cardNumber)}>
            下一步
          </Button>
        </Flex.Item>
      </Flex>
    </>
  );
};

export default StepThree;
